import React from 'react';
import {
  FetchUserMealsConnectorApollo,
  UserMealsSearchConnectorApollo,
} from '@front-activerse/common-components';
import UserMealsIndexContainer from './UserMealsIndexContainer';

interface IUserMealsIndexPage {
  mealsNavigation: {
    path: string;
    translationKey: string;
  }[];
}

const UserMealsIndexPage: React.FC<IUserMealsIndexPage> = ({ mealsNavigation }) => {
  return (
    <FetchUserMealsConnectorApollo>
      {({ ...userMealsData }) => (
        <UserMealsSearchConnectorApollo>
          {(search) => (
            <UserMealsIndexContainer
              {...userMealsData}
              mealsNavigation={mealsNavigation}
              search={search}
            />
          )}
        </UserMealsSearchConnectorApollo>
      )}
    </FetchUserMealsConnectorApollo>
  );
};

export default UserMealsIndexPage;
